import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Colleges = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.977 39.622h-3.79v-22.17h3.89c.398 0 .797-.3.897-.7.1-.4-.1-.799-.399-.998L22.435 3.57c-.298-.2-.598-.2-.897 0L.498 15.754c-.398.2-.498.599-.398.998 0 .5.399.7.797.7h3.89v22.07H.896c-.498 0-.897.4-.897.9 0 .598.399.998.897.998h41.98c.499 0 .898-.4.898-.899.1-.5-.3-.899-.798-.899ZM4.287 15.654l17.65-10.187 17.65 10.187h-35.3Zm2.294 23.968v-22.17h5.684v22.07H6.58v.1Zm7.578 0v-22.17h15.656v22.07H14.159v.1Zm17.45 0v-22.17h5.684v22.07H31.61v.1Z"
  }));
});
Colleges.displayName = 'Colleges';
Colleges.defaultProps = {
  'aria-label': 'Colleges'
};
export default Colleges;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Colleges.js
// module id = 3756
// module chunks = 11